<template>
  <div class="FilterDates">
    <span class="FilterDates-title">Data Range:</span>
    <ul class="FilterDates-container">
      <li
        v-if="!ui.editMode"
        :class="[{'is-active': ui.DateOpened},'Widget-dateRange Widget-link']"
      >
        <a
          class="DateRange"
          @click.prevent="dateRangeToggle"
        >
          <span class="Icon Icon-calendar" />
          <span
            v-if="datesValidated"
            class="DateRange-date"
          >
            <span>{{ datePicker.dates.from | dateFormat }}</span> -
            <span>{{ datePicker.dates.to | dateFormat }}</span>
          </span>
          <span
            v-if="!datesValidated"
            class="DateRange-date"
          > All Time</span>

        </a>
        <a
          v-if="datesValidated"
          class="DateRange"
          @click.prevent="resetDateFilter"
        >
          <span class="Widget-cancelAction Icon Icon-times" />
        </a>
        <div
          v-if="ui.DateOpened"
          class="DatePicker-mask"
          @click.prevent="dateRangeToggle"
        />
        <div
          v-if="ui.DateOpened"
          class="DatePicker"
        >
          <div class="DatePicker-dates">
            <div class="DatePicker-dateInput DatePicker--dateFrom">
              <span class="DatePicker-label">From</span>
              <vue-datePicker
                v-model="datePicker.dates.from"
                :format="datePicker.format"
                placeholder="Select date"
                wrapper-class="VueDataPicker"
                value="date"
              />
            </div>

            <div class="DatePicker-dateInput DatePicker--dateTo">
              <span class="DatePicker-label">To</span>
              <vue-datePicker
                v-model="datePicker.dates.to"
                :format="datePicker.format"
                wrapper-class="VueDataPicker"
                value="date"
                placeholder="Select date"
              />
            </div>
            <div class="Buttons">
              <a
                class="Button Button--green"
                @click.prevent="sendDates"
              ><span
                class="Icon Icon-check"
              /></a>
              <a
                class="Button Button--secondary"
                @click.prevent="abort"
              >
                <span class="Icon Icon-times" />
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import DatePicker from 'vuejs-datepicker';
import CommonOperations from '../../../mixins/common-operations';
import LocalCopy from '../../../lang/en.json';

export default {
  filters: {
    dateFormat(value) {
      function pad(s) {
        return (s < 10) ? `0${s}` : s;
      }

      const d = new Date(value);
      return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
    },
  },
  components: {
    'vue-datePicker': DatePicker,
  },
  mixins: [CommonOperations],
  props: {},
  data() {
    return {
      datePicker: {
        dates: {
          from: '',
          to: '',
        },
        format: 'dd/MM/yyyy',
      },
      datesApplied: false,
      ui: {
        DateOpened: false,
      },
    };
  },
  computed: {
    datesValidated() {
      return this.datePicker.dates.from && this.datePicker.dates.to;
    },
  },
  methods: {

    dateRangeToggle() {
      this.ui.DateOpened = !this.ui.DateOpened;
    },
    resetDateFields() {
      if (!this.datesApplied) {
        this.datePicker.dates.from = '';
        this.datePicker.dates.to = '';
      }
    },
    abort() {
      this.dateRangeToggle();
      this.resetDateFields();
    },
    resetDateFilter() {
      this.datesApplied = false;
      this.ui.DateOpened = false;
      this.resetDateFields();
      this.sendDates();
    },
    sendDates() {
      if (this.datePicker.dates.from !== '' && this.datePicker.dates.to !== '') {
        const fromDate = new Date(this.datePicker.dates.from);
        const toDate = new Date(this.datePicker.dates.to);
        if (this.datePicker.dates.from.length !== this.datePicker.dates.to.length) {
          this.$_commonOperations_emitMessage(LocalCopy.flashMessage.date.datesInvalid, 'warning');
        } else if (fromDate > toDate) {
          this.$_commonOperations_emitMessage(LocalCopy.flashMessage.date.beforeGreater, 'warning');
        } else {
          this.$bus.$emit('filterData', {
            fromDate: this.$_commonOperations_formatDate(this.datePicker.dates.from),
            toDate: this.$_commonOperations_formatDate(this.datePicker.dates.to),
          });
          this.datesApplied = true;
        }
      } else {
        this.$bus.$emit('filterData', {
          fromDate: '',
          toDate: '',
        });
        this.datesApplied = false;
      }
      this.ui.DateOpened = false;
    },
  },
};
</script>
